export default {
  sm: `
  데이터센터에서는 우리가 일상에서 이용하는 다양한
  서비스가 24 시간, 365 일 쉬지 않고 운영되며 새롭게
  만들어진 데이터도 안전하게 저장·관리됩니다. 한 번
  저장된 데이터는 데이터센터에서 인터넷망을 통해
  언제 어디서든 사용자에게 전달되며 이러한 과정은
  1초도 되지 않는 시간에 이루어집니다.
  `,
  md: `
  데이터센터에서는 우리가 일상에서 이용하는 다양한
  서비스가 24 시간, 365 일 쉬지 않고 운영되며 새롭게
  만들어진 데이터도 안전하게 저장·관리됩니다. 한 번
  저장된 데이터는 데이터센터에서 인터넷망을 통해 언제
  어디서든 사용자에게 전달되며 이러한 과정은 1초도
  되지 않는 시간에 이루어집니다.
  `,
  lg: `
  데이터센터에서는 우리가 일상에서 이용하는 다양한 서비스가 24 시간,
  365 일 쉬지 않고 운영되며 새롭게 만들어진 데이터도 안전하게 저장·
  관리됩니다. 한 번 저장된 데이터는 데이터센터에서 인터넷망을 통해
  언제 어디서든 사용자에게 전달되며 이러한 과정은 1초도 되지 않는
  시간에 이루어집니다.
  `,
  xxl: `
  데이터센터에서는 우리가 일상에서 이용하는 다양한 서비스가 24 시간, 365 일 쉬지 않고
  운영되며 새롭게 만들어진 데이터도 안전하게 저장·관리됩니다. 한 번 저장된 데이터는
  데이터센터에서 인터넷망을 통해 언제 어디서든 사용자에게 전달되며 이러한 과정은
  1초도 되지 않는 시간에 이루어집니다.
  `
};
